"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomTokenController = void 0;
const api_1 = require("@streem/api");
const toolbox_1 = require("@streem/toolbox");
const logger_1 = require("../../util/logger");
function credentialsAreAraas(credentials) {
    return credentials.webSocketUri !== undefined;
}
function credentialsAreTwilio(credentials) {
    return typeof credentials === 'string';
}
function credentialsAreChime(credentials) {
    return credentials.Attendee.JoinToken !== undefined;
}
class RoomTokenController {
    constructor() {
        this.log = logger_1.logger.extend('sdk:room_token_controller');
    }
    get roomVideoCredentialsAndPlatform() {
        const credentials = this.getCredentials();
        (0, toolbox_1.invariant)(credentials, 'room credentials must be defined');
        if (credentialsAreAraas(credentials)) {
            return {
                videoPlatform: api_1.StreemApiDeviceSupportedVideoPlatforms.ARAAS,
                roomVideoCredentials: credentials,
            };
        }
        else if (credentialsAreTwilio(credentials)) {
            return {
                videoPlatform: api_1.StreemApiDeviceSupportedVideoPlatforms.TWILIO,
                roomVideoCredentials: credentials,
            };
        }
        else if (credentials === undefined) {
            return {
                videoPlatform: api_1.StreemApiDeviceSupportedVideoPlatforms.INVALID,
                roomVideoCredentials: undefined,
            };
        }
        else if (credentialsAreChime(credentials)) {
            return {
                videoPlatform: api_1.StreemApiDeviceSupportedVideoPlatforms.CHIME,
                roomVideoCredentials: credentials,
            };
        }
        throw new Error('Invalid room credentials');
    }
    fetchRoomVideoCredentials(roomId, localUserId, mediaRegion) {
        return __awaiter(this, void 0, void 0, function* () {
            this.roomVideoCredentials = undefined;
            try {
                const roomVideoCredentialsResponse = yield api_1.StreemAPI.rooms.createRoomVideoCredentials(roomId.toString(), localUserId.toString(), {
                    mediaRegion,
                });
                if (roomVideoCredentialsResponse.chimeRoomVideoCredentials !== undefined) {
                    this.roomVideoCredentials = this.convertChimeResponseToChimeRoomVideoCredentials(roomVideoCredentialsResponse.chimeRoomVideoCredentials);
                }
                else if (roomVideoCredentialsResponse.araasRoomVideoCredentials !== undefined) {
                    (0, toolbox_1.invariant)(roomVideoCredentialsResponse.araasRoomVideoCredentials.webSocketUri, 'Error with ARAAS room video credentials: webSocketUri is undefined');
                    this.roomVideoCredentials = {
                        webSocketUri: roomVideoCredentialsResponse.araasRoomVideoCredentials.webSocketUri,
                    };
                }
                else if (roomVideoCredentialsResponse.twilioRoomVideoCredentials !== undefined) {
                    this.roomVideoCredentials =
                        roomVideoCredentialsResponse.twilioRoomVideoCredentials.token;
                }
                else {
                    this.log.error('Invalid room video credentials response:', roomVideoCredentialsResponse);
                }
            }
            catch (error) {
                this.log.error('Unable to create room video credentials: ', error);
            }
        });
    }
    disconnect() {
        this.roomVideoCredentials = undefined;
    }
    hasToken() {
        return this.getCredentials() !== undefined;
    }
    getCredentials() {
        return this.roomVideoCredentials;
    }
    // The AWS Chime SDKs use Pascal case for their properties, but Streem APIs return camel-case, so
    //       we need to convert
    convertChimeResponseToChimeRoomVideoCredentials(response) {
        const responseMeeting = response.meeting;
        (0, toolbox_1.invariant)(responseMeeting, 'Chime response must have a meeting');
        const chimeAttendee = response.attendee;
        (0, toolbox_1.invariant)(chimeAttendee, 'Chime response must have an attendee');
        const meeting = {
            ExternalMeetingId: responseMeeting.externalMeetingId,
            MediaPlacement: {
                AudioFallbackUrl: responseMeeting.mediaPlacement.audioFallbackUrl,
                AudioHostUrl: responseMeeting.mediaPlacement.audioHostUrl,
                EventIngestionUrl: responseMeeting.mediaPlacement.eventIngestionUrl,
                ScreenDataUrl: responseMeeting.mediaPlacement.screenDataUrl,
                ScreenSharingUrl: responseMeeting.mediaPlacement.screenSharingUrl,
                ScreenViewingUrl: responseMeeting.mediaPlacement.screenViewingUrl,
                SignalingUrl: responseMeeting.mediaPlacement.signalingUrl,
                TurnControlUrl: responseMeeting.mediaPlacement.turnControlUrl,
            },
            MediaRegion: responseMeeting.mediaRegion,
            MeetingArn: responseMeeting.meetingArn,
            MeetingId: responseMeeting.meetingId,
            TenantIds: [], // TODO: figure out if these is needed
        };
        const attendee = {
            AttendeeId: chimeAttendee.attendeeId,
            Capabilities: {
                Audio: chimeAttendee.attendeeCapabilities.audio,
                Content: chimeAttendee.attendeeCapabilities.content,
                Video: chimeAttendee.attendeeCapabilities.video,
            },
            ExternalUserId: chimeAttendee.externalUserId,
            JoinToken: chimeAttendee.joinToken,
        };
        return {
            Meeting: meeting,
            Attendee: attendee,
        };
    }
}
exports.RoomTokenController = RoomTokenController;
//# sourceMappingURL=room_token_controller.js.map